import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import { PortalButton } from "@limitless/portal";
import QuizTryAgainSuccess from "../quiz-try-again-success/QuizTryAgainSuccess";
const useStyles = makeStyles(() => ({
  containerStyles: {
    marginTop: 24
  }
}));
const QuizCta = ({
  content,
  quizCtaClick,
  disableQuizCta,
  quizState,
  isOnboardingView
}) => {
  var _quizState$loading, _content$subSections;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: isOnboardingView ? "left" : "center",
    className: classes.containerStyles
  }, /*#__PURE__*/React.createElement(PortalButton, {
    onClick: () => quizCtaClick && quizCtaClick(),
    disabled: disableQuizCta,
    loading: (_quizState$loading = quizState === null || quizState === void 0 ? void 0 : quizState.loading) !== null && _quizState$loading !== void 0 ? _quizState$loading : false
  }, content.submitCta)), !quizCtaClick && ((_content$subSections = content.subSections) === null || _content$subSections === void 0 ? void 0 : _content$subSections.map((subSection, index) => {
    return /*#__PURE__*/React.createElement(QuizTryAgainSuccess, {
      content: subSection,
      key: index,
      quizState: quizState
    });
  })));
};
QuizCta.propTypes = {
  content: PropTypes.object.isRequired,
  quizState: PropTypes.object,
  quizCtaClick: PropTypes.func,
  disableQuizCta: PropTypes.bool,
  isOnboardingView: PropTypes.bool,
  isLoading: PropTypes.bool
};
export default QuizCta;